import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogThreadCardMessageShowMore from './VeltCommentDialogThreadCardMessageShowMore/VeltCommentDialogThreadCardMessageShowMore';
import VeltCommentDialogThreadCardMessageShowLess from './VeltCommentDialogThreadCardMessageShowLess/VeltCommentDialogThreadCardMessageShowLess';
var VeltCommentDialogThreadCardMessage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-message-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardMessage.ShowMore = VeltCommentDialogThreadCardMessageShowMore;
VeltCommentDialogThreadCardMessage.ShowLess = VeltCommentDialogThreadCardMessageShowLess;
export default VeltCommentDialogThreadCardMessage;
